import clsx from "clsx";

import { MatrixFunction } from "../../../@types/visualization";
import { htmlEncode } from "../../../util";

type Props = {
  functions: Array<MatrixFunction>;
  onMouseEnter: (regionName: string) => void;
  onMouseLeave: () => void;
};

const getItems = (functions: Array<MatrixFunction>) =>
  functions.reduce<Array<string>>((acc, { names }) => {
    const [firstName] = names ?? [];
    if (!acc.includes(firstName.type)) {
      acc.push(firstName.type);
    }
    return acc;
  }, []);

const FunctionMenuList = ({ functions, onMouseEnter, onMouseLeave }: Props) => {
  const menuItems = getItems(functions);
  return (
    <>
      {menuItems.map((item, i) => {
        const functionsMenuItem = htmlEncode(item);
        return (
          <li
            className={clsx(functionsMenuItem, "fit-content")}
            onMouseEnter={() => onMouseEnter(functionsMenuItem)}
            onMouseLeave={onMouseLeave}
            key={`function-${i}`}
          >
            <div className={functionsMenuItem}></div>
            <span>{functionsMenuItem.replace("function", "Entry point")}</span>
          </li>
        );
      })}
    </>
  );
};

export default FunctionMenuList;
